import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ActionSheetController, AlertController, LoadingController, Platform } from 'ionic-angular';
import { WorkflowApproval, GlobalVarApproval } from '@providers/index';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { Utility } from '../../../providers/resources/utility';
import { PreviewAnyFile } from '@ionic-native/preview-any-file/ngx';
import { FileOpener } from '@ionic-native/file-opener';
import { File } from '@ionic-native/file';

@IonicPage()
@Component({
  selector: 'page-item-detail',
  templateUrl: 'item-detail.html'
})
export class ItemDetailPage {
  task: any;
  MyTaskField:any;
  summaryField:any;
  descriptions:any;
  states:any;
  parameter_data:any;
  is_mytask:0;
  fileTransfer: FileTransferObject = this.transfer.create();

  cordova : boolean = false;


  constructor(public navCtrl: NavController, navParams: NavParams, private alertCtrl: AlertController, public actionSheetCtrl: ActionSheetController, public workflow: WorkflowApproval, public globalvar: GlobalVarApproval, public loadingCtrl: LoadingController, private transfer : FileTransfer,public utility : Utility, public platform : Platform, public previewFile: PreviewAnyFile,public fileOpener : FileOpener,public file : File) {
    this.task = navParams.get('task');
    this.is_mytask = navParams.get('is_mytask');
    if(this.task!=undefined){
      this.MyTaskField = JSON.parse(this.task.MyTaskField);
      this.summaryField = JSON.parse(this.task.SummaryField);
      this.get_description();
      this.get_state();
      this.get_parameter_data();
    }

    if(this.platform.is('android')){
      this.cordova = true;
    }else{
      this.cordova = false;
    }
  }

  get_description(){
    let transaction_id = this.task.Transaction_ID;
    if(this.task.Parent_Transaction_ID){
      transaction_id = this.task.Parent_Transaction_ID;
    }
    
    let params = {
      Transaction_ID : transaction_id,
      IS_MOBILE : 1
    };
    this.workflow.get_description(params).subscribe((resp:any) => {
      if(resp.items!=undefined){
        this.descriptions = resp.items;
      }
    }, (err) => {
    });
  }

  get_parameter_data(){
    let params = {
      Transaction_ID : this.task.Transaction_ID,
      Workflow_ID: this.task.Workflow_ID
    };
    this.workflow.get_parameter_data(params).subscribe((resp:any) => {
      if(resp.items.length>0){
        this.parameter_data = resp.items;
      }
    }, (err) => {
    });
  } 

  get_state(){
    let params = {
          node: "state." + this.task.Workflow_State_Idx,
          Workflow_ID: this.task.Workflow_ID,
          Workflow_Task_Idx: this.task.Workflow_Task_Idx
        };
    this.workflow.get_state(params).subscribe((resp:any) => {
      if(resp!=undefined){
        this.states = resp;
      }
    }, (err) => {

    });
  }

  presentActionSheet() {
    let actionSheet = this.actionSheetCtrl.create({
      title: 'Lihat Detail',
      buttons: [
        {
          text: 'Chronology',
          handler: () => {
            this.navCtrl.push('ChronologyPage', {
              task: this.task
            });
          }
        }
      ]
    });
    actionSheet.present();
  }

  change_state(state){
    let alert = this.alertCtrl.create({
      title : 'Konfirmasi',
      subTitle : 'Apakah anda yakin akan melanjutkan Transaksi tanpa melihat detail data ?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text:'Yes',
          handler: data => {
            this.process_change_state(state);
          }
        }
      ]
    });
    alert.present();
  }

  process_change_state(state){
    let alert = this.alertCtrl.create({
      subTitle : state.Description,
      inputs: [
        {
          name: 'Description',
          placeholder: 'Add note here.',
          type: 'text'
        }
      ],
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text:'Yes',
          handler: data => {
            state.new_note = data.Description;
            this.save_new_state(state);
          }
        }
      ]
    });
    alert.present();
  }

  save_new_state(state){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    let params = {
      Transaction_ID : this.task.Transaction_ID,
      Transition_ID : state.Idx,
      User_ID : this.globalvar.app_user.user_attribute.id,
      Transaction_Log_Idx : this.task.Transaction_Log_Idx,
      Description :  "mobile - "+state.new_note
    };
    this.workflow.change_state(params).subscribe((resp:any) => {
      loading.dismiss();
      this.navCtrl.pop();
    }, (err) => {
      loading.dismiss();
    });
  }


  download(file) {
    let url  = file.generated_name;
    let name_real = file.file_name;
    let me = this;
    let loading = this.loadingCtrl.create({
      content: 'Downloading ...'
    });
    loading.present();
    let direktori = this.utility.getDirMyRadiant();
    this.fileTransfer.download(url, direktori + name_real,true).then((entry) => {
      try {
        loading.dismiss();
        console.log(entry,"entry");
        console.log(entry.toURL(),"entry_url");
        entry.file(file => {
          this.fileOpener.open(entry.toURL(), file.type)
          .then(() => console.log('File is opened'))
          .catch(e => console.log('Error opening file', e));
        })

        // this.alertCtrl.create({
        //   title: 'Success',
        //   subTitle: 'Download Complete. Your file has saved in '+,
        //   buttons: ['OK']
        // }).present();
      } catch (error) {}
    }, (error) => {
      // handle error
      console.log(error);
      try {
        loading.dismiss();
        this.alertCtrl.create({
          title: 'Failed',
          subTitle: 'Error Download File. Check your connection and try again.',
          buttons: ['OK']
        }).present();
      } catch (error) {}
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/aproval_erp/item-detail/item-detail.ts